export default __webpack_public_path__ + "city-map-800-82f0552a5108ea65c5a7765a3ca61bc8.png";